/**
 * [关注模块，主要负责用户关注的操作，如增减关注，主播上下线提醒]
 */
$.module('MM.util.follow', function () {
  var ACTIONS = {
    followList: 'user/following_list/{access_token}',
    add: 'user/add_following/{access_token}/{room_id}',
    del: 'user/del_following/{access_token}/{room_id}',
    isFollowed: 'user/is_following?access_token={access_token}&id1={room_id}',
    addFamily:
      'familyroom/add_following?access_token={access_token}&id1={room_id}',
    delFamily:
      'familyroom/del_following?access_token={access_token}&id1={room_id}',
    isFamilyFollowed:
      'familyroom/is_following?access_token={access_token}&id1={room_id}',
  };

  /**
   * 关注主播
   * @param {[type]}   id       [description]
   * @param {Function} callback [description]
   */
  function _add(id, callback) {
    _isFollowing(id, 'user', function (isFollowing) {
      if (isFollowing) {
        MM.ui.messager.warn('您已关注该主播');
      } else {
        _handleFollow(id, 'add', callback);
      }
    });
  }

  /**
   * 添加家族关注
   * @param {[type]}   room_id  [description]
   * @param {Function} callback [description]
   */
  function _addFamily(room_id, callback) {
    _isFollowing(room_id, 'family', function (isFollowing) {
      if (isFollowing) {
        MM.ui.messager.warn('您已关注该家族房');
      } else {
        _handleFollow(room_id, 'addFamily', callback);
      }
    });
  }

  /**
   * 取消关注主播
   * @param  {[type]}   id       [description]
   * @param  {Function} callback [description]
   */
  function _del(id, callback) {
    _handleFollow(id, 'del', callback);
  }

  /**
   * 取消关注家族房
   * @param  {[type]}   room_id  [description]
   * @param  {Function} callback [description]
   */
  function _delFamily(room_id, callback) {
    _handleFollow(room_id, 'delFamily', callback);
  }

  var followData = {};
  /**
   * 是否关注过主播
   * @param  {id}   id       [description]
   * @param  {[room|family]}   type  room | family     [description]
   * @param  {Function} callback [description]
   * @return {Boolean}           [description]
   */
  function _isFollowing(id, type, callback) {
    if (followData[id]) {
      return callback(true);
    }
    if (!MM.user.isLogin()) {
      if (typeof callback === 'function') {
        callback(false);
      }
      return;
    }

    MM.core.getResult({
      url: type === 'family' ? ACTIONS.isFamilyFollowed : ACTIONS.isFollowed,
      requireToken: true,
      data: {
        room_id: id,
      },
      success: function (res) {
        if (typeof callback === 'function') {
          followData[id] = res.data.following;
          callback(res.data.following);
        }
      },
    });
  }

  //处理关注和取消关注
  function _handleFollow(id, type, callback) {
    if (!MM.user.isLogin()) {
      return MM.user.popupLogin();
    }
    if (MM.user.getUserId() === id) {
      return MM.ui.messager.warn('不能关注自己');
    }
    MM.core.getResult({
      url: ACTIONS[type],
      data: {
        room_id: id,
      },
      requireToken: true,
      success: function (res) {
        if (typeof callback == 'function') {
          callback();
        }
      },
    });
  }

  return {
    add: _add,
    addFamily: _addFamily,
    del: _del,
    delFamily: _delFamily,
    isFollowing: _isFollowing,
  };
});
